import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const Header = styled.div`
  margin-top: ${spacing.space12};
`;

export const Title = styled.div`
  margin-top: 0;
  margin-bottom: ${spacing.space16};
`;

export const Ingress = styled.div`
  margin-top: ${spacing.space16};
  margin-bottom: ${spacing.space16};
`;

export const LoginButtonWrapper = styled.div`
  margin-top: ${spacing.space16};
`;
